module.exports = __webpack_public_path__ + "img/search-no-result@2x.f4307b7d.png";